module.exports = __webpack_public_path__ + "img/loading.fdba0f68.png";